import { useForm } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { InputGroup } from 'shared/molecules'
import { Field, fieldButtonClassName } from './Field'
import { Position, usePlacement } from '../placement'

type LineProps = {
	floormapConfig: any[]
	onSubmit: (data: any) => void
}

export const Line = ({ floormapConfig, onSubmit }: LineProps) => {
	const { t } = useTranslation()
	const { handleSubmit, register } = useForm({
		mode: 'onChange'
	})

	const submitLine = ({ points }: any, position: Position = { x: 45, y: 70 }) => {
		onSubmit([
			...floormapConfig,
			{
				type: 'line',
				...position,
				points: points.split(',').map((point: string) => +point),
				tension: 0.1,
				stroke: 'black',
				strokeWidth: 4,
				rotation: 0,
				draggable: true,
				id: crypto.randomUUID()
			}
		])
	}

	usePlacement('line', (position) => handleSubmit((data) => submitLine(data, position))())

	return (
		<Field label={t('Line')} section="line" isPlaceable>
			<form className="space-y-2" onSubmit={handleSubmit((data) => submitLine(data))}>
				<InputGroup
					id="floor-map-line-points"
					label={t('Points')}
					placeholder={t('points (e.g. 0, 0, 100, 0, 100, 100)')}
					{...register('points')}
				/>
				<button type="submit" className={fieldButtonClassName}>
					{t('Add line')}
				</button>
			</form>
		</Field>
	)
}
